module.exports = __webpack_public_path__ + "img/financial-plan.5487f90b.svg";